/**
 * Claves del catálogo SAT c_TipoRegimen (complemento nomina12).
 *
 * ⚠ ESPEJO A MANO de erp_backend/Utils/tipoRegimen.utils.js. Si cambias una lista
 * aquí, cámbiala allá. El backend es la fuente de verdad: él decide qué conceptos le
 * tocan a un asimilado y él rechaza los guardados inválidos; esto sólo sirve para que
 * el formulario del empleado sepa cuándo reaccionar sin pedirle nada al servidor.
 *
 *   02  Sueldos (incluye ingresos del Art. 94 primer párrafo LISR)
 *   03  Jubilados
 *   04  Pensionados
 *   05  Asimilados miembros de sociedades cooperativas de producción
 *   06  Asimilados integrantes de sociedades y asociaciones civiles
 *   07  Asimilados miembros de consejos directivos, de vigilancia, consultivos,
 *       administradores, comisarios y gerentes generales
 *   08  Asimilados comisionistas
 *   09  Asimilados honorarios
 *   10  Asimilados acciones
 *   11  Asimilados otros
 *   12  Jubilados o Pensionados
 *   13  Indemnización o Separación
 *   99  Otro régimen
 */

// El catálogo TipoRegimen no tiene seed: se cargó a mano en Mongo. Un "5" en vez de
// "05" haría fallar cualquier comparación directa, así que todo pasa por aquí.
export const normalizarCTipoRegimen = (valor) => {
    if (valor === null || valor === undefined || valor === "") return "";
    return String(valor).trim().padStart(2, "0");
};

export const REGIMENES_IMSS = ["02", "03", "04"];

// Los siete regímenes de asimilados (Art. 94 LISR, fracciones I a VII). Sin relación
// laboral: ni IMSS, ni prestaciones de la LFT, ni subsidio al empleo.
export const REGIMENES_ASIMILADOS = ["05", "06", "07", "08", "09", "10", "11"];

// c_TipoContrato que el SAT acepta junto a un régimen distinto de 02/03/04:
// 09 pago por hora laborada, 10 comisión laboral, 99 otro contrato.
// Con un contrato 01…08 el PAC rechaza el CFDI de un asimilado.
export const CONTRATOS_SIN_RELACION_LABORAL = ["09", "10", "99"];

export const esRegimenAsimilado = (valor) =>
    REGIMENES_ASIMILADOS.includes(normalizarCTipoRegimen(valor));

export const contratoPermiteRegimenSinRelacionLaboral = (cTipoContrato) =>
    CONTRATOS_SIN_RELACION_LABORAL.includes(normalizarCTipoRegimen(cTipoContrato));
